import { callExternalApi, CallResult } from '../../callExternalApi';
import { PermissionSet, PermissionSetRules, TargetedDenyCapability } from '../../../types';

const BASE_URL = 'api/admin/permission_sets';

export interface PermissionSetRequest {
  name?: string;
  description?: string | null;
  rules?: PermissionSetRules;
  targeted_denies?: string[];
}

export const fetchPermissionSetsApi = async (): Promise<CallResult<PermissionSet[]>> =>
  await callExternalApi<PermissionSet[]>({ url: BASE_URL, method: 'GET' });

export const fetchPermissionSetApi = async (id: string): Promise<CallResult<PermissionSet>> =>
  await callExternalApi<PermissionSet>({ url: `${BASE_URL}/${id}`, method: 'GET' });

export const fetchPermissionSetCapabilitiesApi = async (): Promise<CallResult<TargetedDenyCapability[]>> =>
  await callExternalApi<TargetedDenyCapability[]>({ url: `${BASE_URL}/capabilities`, method: 'GET' });

export const createPermissionSetApi = async (body: PermissionSetRequest): Promise<CallResult<PermissionSet>> =>
  await callExternalApi<PermissionSet>({ url: BASE_URL, method: 'POST', data: { permission_set: body } });

export const updatePermissionSetApi = async (
  id: string,
  body: PermissionSetRequest
): Promise<CallResult<PermissionSet>> =>
  await callExternalApi<PermissionSet>({ url: `${BASE_URL}/${id}`, method: 'PUT', data: { permission_set: body } });

export const deletePermissionSetApi = async (id: string): Promise<CallResult<void>> =>
  await callExternalApi<void>({ url: `${BASE_URL}/${id}`, method: 'DELETE' });
